const { gql } = require('@apollo/client');

export const QUERY_UPDATES = gql`
  query Updates {
    updates {
      all {
        Id
        Name
        Version
        Link
        Description
        SizeMB
        Hash
        IsDownloading
        DownloadProgress
        IsInstalled
        IsMajorUpdate
      }
    }
  }
`;

export const MUTATION_START_UPDATE_BY_ID = gql`
  mutation Updates($id: String) {
    updates {
      download(id: $id)
    }
  }
`;

export const QUERY_UPDATE_BY_ID = gql`
  query Updates($id: String) {
    updates {
      byId(id: $id) {
        Id
        IsDownloading
        DownloadProgress
        IsInstalled
      }
    }
  }
`;
